const lang = document.documentElement.lang.toLowerCase().indexOf("fr") >= 0 ? "fr" : "en";

// This function will always be contained within a promise, hence the resolve
export function getDiversificationResults(resolve) {
    // Make call to json data
    const xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function () {
        if (this.readyState == 4 && this.status == 200) {
            // Call the calculation function
            diversificationCalc(this);
        }
    };
    xhttp.open("GET", `./common/data/data-${lang}.json`, true);
    xhttp.send();

    // Calculate the necessary numbers for building graphs
    const diversificationCalc = (data) => {
        const dataset = JSON.parse(data.responseText);

        // Returns values in percentage (out of 100)
        const sectorResults = getSectorResults(dataset.goingGlobal.sectors);
        const stockResults = getStockResults(dataset.goingGlobal.stocks);
        const growthResults = dataset.growth;

        // Send back results to promise inside resolve()
        resolve({
            sectors: sectorResults,
            stocks: stockResults,
            growth: growthResults,
        });
    };

    // Get stats for sectors graphs: percentage of market which is in top 3 sectors, Canada vs. World
    const getSectorResults = (sectors) => {
        // Calculate highest Canadian sectors
        const topCanadianSectors = sectors.canada.breakdown
            .sort((a, b) => {
                return a.weight < b.weight ? 1 : -1;
            })
            .slice(0, 3);

        //Calculate highest world sectors
        const topWorldSectors = sectors.world.breakdown
            .sort((a, b) => {
                return a.weight < b.weight ? 1 : -1;
            })
            .slice(0, 3);

        let topCanadianSectorsAmount = 0;
        let topWorldSectorsAmount = 0;

        // Add them up
        topCanadianSectors.forEach((sector) => {
            topCanadianSectorsAmount += sector.weight;
        });

        topWorldSectors.forEach((sector) => {
            topWorldSectorsAmount += sector.weight;
        });

        return {
            canada: {
                total: topCanadianSectorsAmount,
                breakdown: topCanadianSectors,
            },
            world: {
                total: topWorldSectorsAmount,
                breakdown: topWorldSectors,
            },
        };
    };

    // Get stats for stocks graphs: percentage of market which is conteined by top 10 stocks, Canada vs. World
    const getStockResults = (stocks) => {
        const topCanadianStocks = stocks.canada.breakdown.sort((a, b) => (a.weight < b.weight ? 1 : -1));

        //Calculate highest world sectors
        const topWorldStocks = stocks.world.breakdown.sort((a, b) => (a.weight < b.weight ? 1 : -1));

        let topCanadianStocksAmount = 0;
        let topWorldStocksAmount = 0;

        //Add up top ten Canadian stocks
        stocks.canada.breakdown.forEach((stock) => (topCanadianStocksAmount += stock.weight));

        //Add up top ten world stocks
        stocks.world.breakdown.forEach((stock) => (topWorldStocksAmount += stock.weight));

        return {
            canada: {
                total: topCanadianStocksAmount,
                breakdown: topCanadianStocks,
            },
            world: {
                total: topWorldStocksAmount,
                breakdown: topWorldStocks,
            },
        };
    };
}
